import React from "react";
import ActiveFormActions from "data/ActiveFormActions";
import safeDispatch from "data/util/safeDispatch";

const NoFormView = () => {
    React.useEffect(() => {
        safeDispatch({
            type: ActiveFormActions.NO_FORM_TO_RENDER,
        });
    }, []);
    return <h2>Please select a record above</h2>;
};

export default NoFormView;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/views/NoFormView.js